import React from "react";

import { templates } from "@reactivated";

import { EventHero } from "../components/Heros/Event";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import { TrackedStreamField } from "../components/PageSkeleton/TrackedStreamField";

export const Template = (props: templates.EventPageTemplate) => (
    <PageSkeleton
        {...props.page}
        isPreview={props.is_preview}
        // The hero block renders the page title as a visible <h1>.
        hasVisibleH1={props.page.body.value.some(
            (block) => block.type === "hero",
        )}
    >
        <TrackedStreamField
            components={{
                ...toolboxComponents,
                hero: () => <EventHero {...props.page} />,
            }}
            value={props.page.body.value}
            tagName={React.Fragment}
        />
    </PageSkeleton>
);
